/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Container, Card } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, InputAdornment, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import PropTypes, { func } from 'prop-types'
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import SearchNotFound from '../../../SearchNotFound';
import Chip from '@material-ui/core/Chip';
import { AlertDialog } from './../../Common/AlertDialog';
import { makeStyles } from '@material-ui/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import { CustomTable } from './CustomTable';
import moment from 'moment';
import LoadingButton from '@mui/lab/LoadingButton';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'invoiceNumber',
        numeric: false,
        disablePadding: false,
        label: 'GRN Number',
        align: "left"
    },
    {
        id: 'farmerCode',
        numeric: false,
        disablePadding: false,
        label: 'Farmer Code(ACS)',
        align: "left"
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'Farmer Name',
        align: "left"
    },
    {
        id: 'price',
        numeric: false,
        disablePadding: false,
        label: 'Price',
        align: "left"
    },
    {
        id: 'quanity',
        numeric: false,
        disablePadding: false,
        label: 'Quantity',
        align: "left"
    },
    {
        id: 'date',
        numeric: false,
        disablePadding: false,
        label: 'Date',
        align: "left"
    },
    {
        id: 'time',
        numeric: false,
        disablePadding: false,
        label: 'Time',
        align: "left"
    },
    {
        id: 'factoryName',
        numeric: false,
        disablePadding: false,
        label: 'FCC',
        align: "left"
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'Status',
        align: "left"
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'Action',
        align: "center"
    },
];

const headCellsOne = [
    {
        id: 'invoiceNumber',
        numeric: false,
        disablePadding: false,
        label: 'Invoice Number',
        align: "left"
    },
    {
        id: 'factoryName',
        numeric: false,
        disablePadding: false,
        label: 'Fresh Collection Centre',
        align: "left"
    },
    {
        id: 'farmerCode',
        numeric: false,
        disablePadding: false,
        label: 'Supplier code',
        align: "left"
    },
    {
        id: 'totalAmount',
        numeric: false,
        disablePadding: false,
        label: 'Total amount',
        align: "right"
    },
    {
        id: 'statusID',
        numeric: false,
        disablePadding: false,
        label: 'Status',
        align: "left"
    },
    {
        id: 'rejectReason',
        numeric: false,
        disablePadding: false,
        label: 'Reject Reason',
        align: "left"
    }
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

function EnhancedTableHeadOne(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCellsOne.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                    >
                        {headCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));
var screenCode = 'GRNSUMMARYAPPROVAL';

export default function GRNSummaryApproval(props) {

    const classes = useStyles();
    const [message, setMessage] = useState("Approve Confirmation");
    const [rowSelection, setRowSelection] = useState({});
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [approveFarmerDetails, setApproveFarmerDetails] = useState({
        farmerID: 0,
        farmerStatus: 0,
        collectionCenterID: 0,
        farmerCode: "",
        givenName: "",
        navisionNumber: "",

    });
    const [approveFarmer, setApproveFarmer] = useState(0);
    const [approveStatus, setApproveStatus] = useState(0);
    const [rejectFarmer, setRejectFarmer] = useState(0);
    const [rejectStatus, setRejectStatus] = useState(0);
    const [farmerDetails, setFarmerDetails] = useState([]);
    const [totalOfTotalAmount, setTotalOfTotalAmount] = useState(0);
    const [farmerDetails1, setFarmerDetails1] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [isEnable, setIsEnable] = useState(true);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [userID, setUserID] = useState(0);
    const [userAccess, setUserAccess] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [GRNRejectDetails, setGRNRejectDetails] = useState([]);
    let encrypted = "";
    const navigate = useNavigate();
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isFDCFirstUser: false,
        isFDCSecondUser: false,
        isFinancialFirstUser: false,
        isFinancialSecondUser: false
    });
    const [cropData, setCropData] = useState({
        farmerName: ''
    });
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        rejectReason: "",
        isActive: "0",
        transactionType: "SLIPS",
        date: "0"
    });
    const [date, setDate] = useState(new Date());
    const productcatogerySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number()
    });
    const [selectedData, setSelectedData] = useState([]);
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            isActive: formData.isActive,
            transactionType: formData.transactionType,
            date: date.toISOString().split('T')[0]
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
            setIsEnable(false);
            trackPromise(GetGRNSummaryApprovalData(values));

        },
    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        const IDdata = JSON.parse(sessionStorage.getItem('farmer-listing-page-search-parameters-id'));
        const tablePage = JSON.parse(sessionStorage.getItem('farmer-table-page'));

        if (IDdata !== null) {
            setPage(tablePage);
            setIsEnable(false);
        }
        getPermissions(IDdata, tablePage);
    }, []);

    useEffect(() => {
        sessionStorage.removeItem('farmer-listing-page-search-parameters-id');
        sessionStorage.removeItem('farmer-table-page');
    }, []);

    useEffect(() => {
        if (approveFarmer != 0) {
            handleConfirm(approveFarmer, approveStatus)
        }
    }, [approveFarmer]);

    useEffect(() => {
        if (rejectFarmer != 0) {
            handleReject(rejectFarmer, rejectStatus)
        }
    }, [rejectFarmer]);

    useEffect(() => {
        setSelectedData([]);
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setSelectedData([]);
        setFarmerDetails([]);
        setPage(0);
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setFarmerDetails([]);
        setPage(0);
    }, [formik.values.isActive]);

    useEffect(() => {
        setFarmerDetails([]);
        setPage(0);
    }, [formik.values.farmerTypeID]);

    useEffect(() => {
        setSelectedData([]);
        setFarmerDetails([]);
        setPage(0);
    }, [formik.values.date]);

    useEffect(() => {
        handleSearch(cropData.farmerName);
    }, [cropData.farmerName]);

    useEffect(() => {
        trackPromise(GetGRNSummaryApprovalData(values));
    }, [formik.values.transactionType]);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('date');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    async function getPermissions(IDdata, tablePage) {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWGRNSUMMARYAPPROVAL');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
        var isFDCFirstUser = permissions.find(p => p.permissionCode == 'FDCFIRSTAPPROVAL');
        var isFDCSecondUser = permissions.find(p => p.permissionCode == 'FDCSECONDAPPROVAL');
        var isFinancialFirstUser = permissions.find(p => p.permissionCode == 'FINANCIALFIRSTAPPROVAL');
        var isFinancialSecondUser = permissions.find(p => p.permissionCode == 'FINANCIALSECONDAPPROVAL');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isFDCFirstUser: isFDCFirstUser !== undefined,
            isFDCSecondUser: isFDCSecondUser !== undefined,
            isFinancialFirstUser: isFinancialFirstUser !== undefined,
            isFinancialSecondUser: isFinancialSecondUser !== undefined
        });

        const isInitialLoad = IDdata === null;

        if (isInitialLoad) {
            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
                userID: parseInt(TokenDecoder.getUserIDFromToken())
            })
        }
        else {
            setValues({
                ...values,
                groupID: IDdata.groupID,
                operationEntityID: IDdata.operationEntityID,
                isActive: IDdata.isActive
            })
            setPage(tablePage);
        }
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
        setUserID(parseInt(TokenDecoder.getUserIDFromToken()))
        trackPromise(GetAllGroups());
    }

    async function GetGRNSummaryApprovalData(values) {
        setRowSelection({});
        setSelectedData([]);
        setFarmerDetails([]);
        const res = await services.GetGRNSummaryApprovalData(values);
        if (res.statusCode == "Success") {
            const rejectedList = [];
            res.data.forEach(x => {
                x.transactionType = x.statusID != 1 ? x.transactionType : x.transactionType == "CARG" ? x.transactionType : formik.values.transactionType
                x.date = moment(x.date).format("YYYY-MM-DD");
                x.time = moment(x.time).format('hh:mm:ss a');
                if (!(x.statusID >= 1 && x.statusID <= 9)) {
                    x.statusID = 10;
                }
                if (x.modifiedBy == userID && x.statusID != 1) {
                    x.userAccess = 1;
                }
                else {
                    x.userAccess = 0;
                }

                if (x.statusID >= 6 && x.statusID <= 9) {
                    rejectedList.push(x);
                }

            });

            setFarmerDetails(res.data);
            setGRNRejectDetails(rejectedList);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    function generateGroupForDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.groupID} value={x.groupID}>{x.groupName}</MenuItem>)
            });
        }
        return items
    }

    function generateOperationEntityForDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.factoryID} value={x.factoryID}>{x.factoryName}</MenuItem>)
            });
        }
        return items
    }

    async function handleSearch(data) {
        if (farmerDetails == null || farmerDetails.length == 0) {
            setFarmerDetails(farmerDetails1)
        }
        const Default = [];
        for (let i = 0; i < farmerDetails.length; i++) {
            const obj = farmerDetails[i];

            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const propertyValue = obj[key];
                    if (propertyValue != null) {
                        const newPropertyValue = propertyValue.toString().toLowerCase();
                        if (typeof newPropertyValue === 'string' && newPropertyValue.includes(data.toLowerCase())) {
                            Default.push(obj);
                            break;
                        }
                    }
                }
            }
        }
        if (data == '') {
            setFarmerDetails(farmerDetails1)
            return;
        }
        setFarmerDetails(Default)
    }

    function clear() {
        setIsEnable(true);
        setFarmerDetails([]);
        setDate(new Date());
        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory),
            transactionType: "SLIPS",
            isActive: formData.isActive,
            date: date.toISOString().split('T')[0]
        })
    }

    async function ApproveFarmer(selectedData) {
        setIsLoading(true);
        var res = await services.UpdateGRNSummaryApprovalStatus(selectedData);
        if (res.statusCode === "Success") {
            setSelectedData([]);
            trackPromise(GetGRNSummaryApprovalData(values));
            setValues({
                ...values,
                transactionType: "SLIPS",
            })
            toast.success(res.message);
            setIsLoading(false);
        } else {
            toast.error("Error occured in Farmer Approval");
            setIsLoading(false);
        }
    }

    function confirmData(y) {
        if (y) {
            trackPromise(ApproveFarmer(selectedData));
        }
    }

    async function handleConfirm() {
        setEnableConfirmMessage(true);
    }

    const [openOne, setOpenOne] = useState(false);
    const [openTwo, setOpenTwo] = useState(false);
    const handleCloseOne = () => {
        setOpenOne(false);
        setApproveFarmerDetails({
            ...approveFarmerDetails,
            farmerID: "0",
            farmerStatus: "0"
        })
        setFormData({
            ...formData,
            rejectReason: ""
        })
    };

    const handleCloseTwo = () => {
        setOpenTwo(false);
    };

    function handleReject() {
        setOpenOne(true);
    }

    function handleRejectReason(e) {
        const value = e.target.value;
        const containsLetters = /[a-zA-Z]/.test(value);

        if (value === '' || containsLetters) {
            setFormData({
                ...formData,
                [e.target.name]: value
            })
        }
    }

    async function SupplierReject() {
        setIsLoading(true);
        if (formData.rejectReason != "") {
            let model = {
                InvoiceNumber: selectedData.farmerID,
                StatusID: parseInt(selectedData.farmerStatus),
                IsReinitiate: selectedData.isReinitiate,
                RejectReason: formData.rejectReason,
                ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken())
            }
            let modelArray = []
            selectedData.forEach(data => {
                model = {
                    InvoiceNumber: data.invoiceNumber,
                    StatusID: parseInt(data.statusID) + 5,
                    IsReinitiate: data.isReinitiate,
                    RejectReason: formData.rejectReason,
                    ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
                }
                modelArray.push(model);
            });
            var res = await services.RejectGRNSummaryApprovalStatus(modelArray);
            if (res.statusCode === "Success") {
                toast.success(res.message);
                setIsLoading(false);
                trackPromise(GetGRNSummaryApprovalData(values));
                setValues({
                    ...values,
                    transactionType: "SLIPS",
                })
                handleCloseOne();
            } else {
                toast.error("Error occured in GRN reject");
                handleCloseOne();
                setIsLoading(false);
            }
        }
        else {
            toast.error("Reject Reason Required");
        }
    }

    function handleRejectDetalisList() {
        setOpenTwo(true);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="GRN Summary Approval  |  FAPS">
                <Container maxWidth>
                    <CommonPageHeader
                        path="/dashboard"
                        btname="Back"
                        pageName="GRN Summary Approval"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {generateGroupForDropDownMenu(groupList)}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> All</MenuItem>
                                        {generateOperationEntityForDropDownMenu(operationEntityList)}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Status"
                                        value={formik.values.isActive}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('isActive')}
                                        error={Boolean(touched.isActive && errors.isActive)}
                                        helperText={touched.isActive && errors.isActive}
                                    >
                                        <MenuItem key={0} value={0}>
                                            All Status
                                        </MenuItem>
                                        <MenuItem value={1}> New</MenuItem>
                                        <MenuItem value={2}> FDC First Approved</MenuItem>
                                        <MenuItem value={3}> FDC Second Approved</MenuItem>
                                        <MenuItem value={4}> Finance First Approved</MenuItem>
                                        <MenuItem value={5}> Finance Second Approved</MenuItem>
                                        <MenuItem value={6}> FDC First Rejected</MenuItem>
                                        <MenuItem value={7}> FDC Second Rejected</MenuItem>
                                        <MenuItem value={8}> Finance First Rejected</MenuItem>
                                        <MenuItem value={9}> Finance Second Rejected</MenuItem>
                                    </TextField>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        id="date"
                                        label="Date"
                                        type="date"
                                        value={formik.values.date}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('date')}
                                        error={Boolean(touched.date && errors.date)}
                                        helperText={touched.date && errors.date}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"></InputAdornment>,
                                            inputProps: {
                                                max: new Date().toISOString().split('T')[0],
                                            }
                                        }}
                                    />
                                    <Grid item md={4} xs={12}>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="error"
                                                onClick={() => clear()}
                                            > Clear</Button>
                                            <Button
                                                type="submit"
                                                variant="outlined"
                                                color="secondary"
                                            >Search</Button>
                                        </Stack>
                                    </Grid>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    <br />
                    {farmerDetails.length == 0 ?
                        <SearchNotFound searchQuery="Goods Received Note Summary Approval" />
                        : null}
                    <>
                        {farmerDetails.length != 0 && permissionList.isFDCFirstUser == true ?
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Grid item md={3} xs={12}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Transaction Type *"
                                        disabled={farmerDetails.filter(x => x.statusID == 1).length != 0 ? false : true}
                                        value={formik.values.transactionType}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('transactionType')}
                                    >
                                        <MenuItem value={'SLIPS'}> SLIPS</MenuItem>
                                        <MenuItem value={'CEFT'}> CEFT</MenuItem>
                                    </TextField>
                                </Grid>

                            </Stack>
                            : null}
                        <br />
                        {isEnable == false ?
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Grid container spacing={2}>
                                    {GRNRejectDetails.length > 0 && farmerDetails.length > 0 &&
                                        <Grid item>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="left">
                                                <Chip label="Rejected GRN Summary" variant="outlined" color="error"
                                                    onClick={handleRejectDetalisList}
                                                />
                                            </Stack>
                                        </Grid>
                                    }
                                    {/* {totalOfTotalAmount != 0 &&
                                        <Grid item>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <h4>Total Amount : {parseFloat(totalOfTotalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h4>
                                            </Stack>
                                        </Grid>
                                    } */}
                                </Grid>
                            </Stack> : null
                        }
                        <br />
                        <Card>
                            <CustomTable
                                tableData={farmerDetails}
                                setFarmerDetails={setFarmerDetails}
                                factoryType={factoryType}
                                setSelectedData={setSelectedData}
                                selectedData={selectedData}
                                rowSelection={rowSelection}
                                setRowSelection={setRowSelection}
                                userAccess={userAccess}
                                setTotalOfTotalAmount={setTotalOfTotalAmount}
                                totalOfTotalAmount={totalOfTotalAmount}
                                isFDCFirstUser={permissionList.isFDCFirstUser}
                                isFDCSecondUser={permissionList.isFDCSecondUser}
                                isFinancialFirstUser={permissionList.isFinancialFirstUser}
                                isFinancialSecondUser={permissionList.isFinancialSecondUser}
                            />
                        </Card>
                    </>
                    {farmerDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <LoadingButton
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem', backgroundColor: 'green' }}
                                className={classes.colorRecord}
                                onClick={handleConfirm}
                                disabled={!selectedData.length > 0}
                                loading={isLoading}
                            >
                                Approve
                            </LoadingButton>
                            <LoadingButton
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                className={classes.colorRecord}
                                onClick={handleReject}
                                disabled={!selectedData.length > 0}
                                loading={isLoading}
                            >
                                Reject
                            </LoadingButton>

                        </Box>
                        : null}
                </Container>

                <div hidden={true}>
                    <Grid item>
                        <AlertDialog
                            confirmData={confirmData}
                            headerMessage={message}
                            viewPopup={EnableConfirmMessage}
                            discription={selectedData.length > 1 ? "Are you sure you want to approve these invoices?" : "Are you sure you want to approve this invoice?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <Dialog fullWidth={true} maxWidth='sm' onClose={handleCloseOne} aria-labelledby="customized-dialog-title" open={openOne}>
                    <DialogTitle id="customized-dialog-title" onClose={handleCloseOne}>
                        Invoice Reject !
                    </DialogTitle>
                    <DialogContent dividers>
                        <Grid item md={12} xs={12}>
                            <TextField
                                fullWidth
                                id="outlined-multiline-static"
                                label="Reject Reason *"
                                name='rejectReason'
                                value={formData.rejectReason}
                                onChange={(e) => { handleRejectReason(e) }}
                                multiline
                                rows={4}
                                variant="outlined"
                            />
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={() => trackPromise(SupplierReject())} variant="contained" color="error">
                            Reject
                        </Button>
                        <Button autoFocus onClick={handleCloseOne} variant="outlined" color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog fullWidth={true} maxWidth='lg' onClose={handleCloseTwo} aria-labelledby="customized-dialog-title" open={openTwo}>
                    <DialogTitle id="customized-dialog-title" onClose={handleCloseTwo}>
                        Rejected GRN Summary List
                    </DialogTitle>
                    <DialogContent dividers>
                        <Paper className={classes.paper}>
                            <TableContainer>
                                <Table
                                    className={classes.table}
                                    aria-labelledby="tableTitle"
                                    aria-label="enhanced table"
                                >
                                    <EnhancedTableHeadOne
                                        classes={classes}
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={GRNRejectDetails.length}
                                    />
                                    <TableBody>
                                        {stableSort(GRNRejectDetails, getComparator(order, orderBy))
                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;

                                                return (
                                                    <TableRow>
                                                        <TableCell component="th" id={labelId} scope="row" >
                                                            {row.invoiceNumber}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.factoryName}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.farmerCode}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            {row.totalAmount == 0 ? "-" : parseFloat(row.totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.statusID == 1 ? <Chip size="small" label="New" style={{ color: 'green' }} />
                                                                : row.statusID == 2 ? <Chip size="small" label="FDC First Approved" style={{ color: 'orange' }} />
                                                                    : row.statusID == 3 ? <Chip size="small" label="FDC First Approved" style={{ color: '#B414F9' }} />
                                                                        : row.statusID == 4 ? <Chip size="small" label="Finance First Approved" style={{ color: 'blue' }} />
                                                                            : row.statusID == 5 ? <Chip size="small" label="Finance Second Approved" style={{ color: 'blue' }} />
                                                                                : row.statusID == 6 ? <Chip size="small" label="FDC First Rejected" style={{ color: 'red' }} />
                                                                                    : row.statusID == 7 ? <Chip size="small" label="FDC Second Rejected" style={{ color: 'red' }} />
                                                                                        : row.statusID == 8 ? <Chip size="small" label="Finance First Rejected" style={{ color: 'red' }} />
                                                                                            : row.statusID == 9 ? <Chip size="small" label="Finance Second Rejected" style={{ color: 'red' }} />
                                                                                                : <Chip size="small" label="Active" style={{ color: 'green' }} />}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.rejectReason}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={handleCloseTwo} color="secondary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Page>
        </>
    );
}

